import React, { useState } from 'react';
import './Home.css';
import logo from './img/logo.png';

function Home() {
  const [show, setShow] = useState(false);

  const handleLinkClick = () => {
    setShow(false);
  };

  return (
    <div className="home" id="Home">
      <div className="home__bg">
        <div className="header d__flex align__items__center pxy__30">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="navigation pxy__30">
            <ul className="navbar d__flex">
              <a href="#Home">
                <li className="nav__items mx__15">HOME</li>
              </a>
              <a href="#About">
                <li className="nav__items mx__15">ABOUT</li>
              </a>
              <a href="#Experience">
                <li className="nav__items mx__15">EXPERIENCE</li>
              </a>
              <a href="#Services">
                <li className="nav__items mx__15">SKILLS</li>
              </a>
              <a href="#Project">
                <li className="nav__items mx__15">PROJECT</li>
              </a>
              <a href="#Contact">
                <li className="nav__items mx__15">CONTACT</li>
              </a>
            </ul>
          </div>
          <div className="toggle__menu">
            <svg
              onClick={() => setShow(!show)}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-justify white pointer"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </div>
          {show ? (
            <div className="sideNavbar">
              <ul className="sidebar d__flex">
                <li className="sideNavbar">
                  <a href="#Home" onClick={handleLinkClick}>
                    Home
                  </a>
                </li>
            <li className="sideNavbar">
              <a href="#About" onClick={handleLinkClick}>About</a>
            </li>
            <li className="sideNavbar">
              <a href="#Experience" onClick={handleLinkClick}>Experience</a>
            </li>
            <li className="sideNavbar">
              <a href="#Services" onClick={handleLinkClick}>Skills</a>
            </li>
            <li className="sideNavbar">
              <a href="#Project" onClick={handleLinkClick}>Project</a>
            </li>
            <li className="sideNavbar">
              <a href="#Contact" onClick={handleLinkClick}>Contact</a>
            </li>
              </ul>
          </div>
           ) : null}
        </div>
                <div className="container">
                <div className="home__content">
                    <div className="home__meta">
                        <h1 className="home__text pz__10">
                        WELCOME TO MY WORLD
                        </h1>
                        <h2 className="home__text pz__10 my__name">
                            Hi , I'm Hoshen Ishay .
                        </h2>
                        <h3 className="home__text pz__10 sweet">
                        Full Stack Developer .
                        </h3>
                        <h4 className="home__text pz__10">
                  <svg onClick={()=> window.open("https://www.linkedin.com/in/hoshen-ishay-3365041bb/", "_blank")} xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                  </svg>
                  <svg onClick={()=> window.open("https://github.com/HoshenIshay", "_blank")} xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-github" viewBox="0 0 16 16">
                    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                  </svg>
                        </h4>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export default Home
